import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Box, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {},
    loader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: '#00000024',
        zIndex: 1301,
    },
    spinner: {
        textAlign: 'center'
    },
    messageContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '500px',
        backgroundColor: 'black',
        color: 'white',
        padding: '15px',
        marginBottom: '30px',
        [theme.breakpoints.down('xs')]: {
            width: 'fit-content',
        }
    },
}));

const LoaderCustom = props => {
    const classes = useStyles();
    const { 
        children, 
        isLoading, 
        loaderSize, 
        isLoaderMessageRequired = false, 
        loaderMessage, 
        rootClassName,
    } = props;

    return (
        <>
            {isLoading ?
                <Box className={clsx(classes.loader, rootClassName)} component="div">
                    {isLoaderMessageRequired &&
                        <p className={classes.messageContent}>{loaderMessage}</p>
                    }
                    <CircularProgress size={loaderSize ? loaderSize : 80} className={classes.spinner} />
                </Box>
                :
                <></>
            }
        </>
    );
}

export default LoaderCustom;